<template>
  <Alert class="alert" v-show="alertData.show" :type="alertData.type" :show-icon="alertData.show_icon" :closable="alertData.closable">
    <span v-text="alertData.content"></span>
  </Alert>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: "alert",
    computed: {
      ...mapGetters({
        alertData: 'prompt/alertData'
      }),
    },
  }
</script>

<style scoped>
  .alert{
    position: fixed;
    top: 0;
    left: 50%;
    width: 1440px;
    margin-left: -720px;
    height: 50px;
    line-height: 32px;
    text-align: center;
    color: rgba(0,0,0,.87);
    z-index: 20000;
  }
</style>
